/**
 * Icon and tile colors per leave type, for the type tiles in the form and the "Soort" column of the list.
 * Presentation only: the leave types themselves come from the API (`leave/type`).
 */
export interface LeaveTypeStyle {
    /** Font Awesome name without prefix */
    icon: string;
    fg: string;
    bg: string;
}

// TODO(design): which leave types exist is unconfirmed (README open point 8). The types are rows in the
//  leave_types table, so this maps the keys known today; unknown keys get the grey calendar tile.
const STYLES: Record<string, LeaveTypeStyle> = {
    holiday: {icon: 'sun', fg: '#136b42', bg: '#d9f5e6'},
    work_from_home: {icon: 'house', fg: '#3851c4', bg: '#e3e9ff'},
    special_leave: {icon: 'star', fg: '#5b3cc4', bg: '#ede7fb'},
    illness: {icon: 'kit-medical', fg: '#a61b1b', bg: '#fde2e1'},
    short_absence: {icon: 'hourglass-half', fg: '#8a5300', bg: '#fff0d6'},
    cursus: {icon: 'graduation-cap', fg: '#0e7490', bg: '#dcf2f7'},
    external: {icon: 'building', fg: '#b4531a', bg: '#fde8da'},
    staff_outing: {icon: 'champagne-glasses', fg: '#9d2468', bg: '#fbe3f0'},
    time_for_time: {icon: 'clock-rotate-left', fg: '#4b5563', bg: '#eef0f2'},
};

const FALLBACK: LeaveTypeStyle = {icon: 'calendar', fg: '#4b5563', bg: '#eef0f2'};

export function leaveTypeStyle(key: string | null | undefined): LeaveTypeStyle {
    return (key && STYLES[key]) || FALLBACK;
}

export const WEEKDAYS = [
    {key: 'monday', short: 'ma', name: 'maandag'},
    {key: 'tuesday', short: 'di', name: 'dinsdag'},
    {key: 'wednesday', short: 'wo', name: 'woensdag'},
    {key: 'thursday', short: 'do', name: 'donderdag'},
    {key: 'friday', short: 'vr', name: 'vrijdag'},
    {key: 'saturday', short: 'za', name: 'zaterdag'},
    {key: 'sunday', short: 'zo', name: 'zondag'},
] as const;

/** "8:00" for 480 minutes. */
export function hoursLabel(minutes: number): string {
    const total = Math.max(0, Math.round(minutes));
    return `${Math.floor(total / 60)}:${String(total % 60).padStart(2, '0')}`;
}
